<template>
  <el-menu
    :default-active="activeIndex"
    class="el-menu-demo header"
    mode="horizontal"
    @select="handleSelect">
    <el-menu-item :router="true" :index="route.meta.menuKey" v-for="route in headerItems">
      <router-link :to="route">
        {{route.meta.title}}
      </router-link>
    </el-menu-item>
    <el-menu-item index="MoveHookah" v-if="$store.getters.roles.includes('ROLE_HOOKAH')">
      <router-link :to="{name: 'MoveHookah'}">
        Перемещение табаков
      </router-link>
    </el-menu-item>
    <div class="right-menu">
      <div class="avatar-container right-menu-item" v-if="!currentUser.name && $store.getters.token">
        <div class="avatar-wrapper">
          <i class="el-icon-loading" style="font-size: 24px;"></i>
        </div>
      </div>
      <el-dropdown class="avatar-container right-menu-item" @command="handleDropdownCommand" trigger="click"
                   v-show="currentUser.name">
        <div class="avatar-wrapper">
          {{currentUser.name}}
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">
            <span>Выйти</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

  </el-menu>
</template>

<script>
  import {get} from 'lodash'
  import {mapGetters} from 'vuex'

  export default {
    name: 'HeaderComponent',
    data() {
      return {
        activeIndex: '',
        headerItems: []
      }
    },
    created() {
      this.activeIndex = get(this.$router.currentRoute, 'meta.menuKey')
      this.$router.beforeEach((to, from, next) => {
        this.activeIndex = get(to, 'meta.menuKey')
        next()
      })
    },
    watch: {
      'permission_routers': {
        handler() {
          if (this.permission_routers) {
            this.headerItems = this.permission_routers.filter(route => {
              return route.meta && route.meta.showInMenu && this.hasPermission(route)
            })
          }
        },
        deep: true
      }
    },
    computed: {
      ...mapGetters(['permission_routers', 'roles']),
      currentUser() {
        return this.$store.state.user
      }
    },
    methods: {
      handleDropdownCommand(command) {
        switch (command) {
          case 'logout':
            this.logout();
            break;
        }
      },
      hasPermission(route) {
        if (!route.meta || route.meta.onlyAuthenticated || !route.meta.roles) return true
        return this.roles.some(userRole => route.meta.roles.some(routeRole => routeRole === userRole))
      },
      handleSelect() {

      },
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          this.$router.push('/login')
//          location.reload() // In order to re-instantiate the vue-router object to avoid bugs
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header {
    .right-menu {
      float: right;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      flex-direction: column;

      &:focus {
        outline: none;
      }
      .right-menu-item {
        display: inline-block;
        margin: 0 8px;
      }
      .screenfull {
        height: 20px;
      }
      .international {
        vertical-align: top;
        .international-icon {
          font-size: 20px;
          cursor: pointer;
          vertical-align: -5px;
        }
      }
      .theme-switch {
        vertical-align: 15px;
      }
      .avatar-container {
        margin-right: 30px;
        .avatar-wrapper {
          cursor: pointer;
          position: relative;
          user-select: none;
          outline: 0;
          .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }
          .el-icon-caret-bottom {
            position: absolute;
            right: -15px;
            top: 10px;
            font-size: 12px;
          }
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/Header/index.vue